import {
  ISubscriptionPlanCard,
  IUserSubscriptionEntity,
  SUBSCRIPTION_PLAN,
  SUBSCRIPTION_RECURRENT,
} from 'interfaces/subscriptions';

export const getPlanToDisplay = (
  userSubscription: IUserSubscriptionEntity | null,
  subscriptionData: ISubscriptionPlanCard,
  isYearly: boolean,
) => {
  if (!userSubscription) {
    return false;
  }

  const isPlanMatch = userSubscription.subscriptionPlan === subscriptionData.tariff;

  if (isPlanMatch && userSubscription.subscriptionPlan === SUBSCRIPTION_PLAN.FREE) {
    return true;
  }

  const isRecurrentMatch = isYearly
    ? userSubscription.recurrent === SUBSCRIPTION_RECURRENT.ANNUALLY
    : userSubscription.recurrent === SUBSCRIPTION_RECURRENT.MONTHLY;

  return isPlanMatch && isRecurrentMatch;
};
